import $ from 'jquery';
import '@accessible360/accessible-slick';

declare global {
	interface JQuery {
		slick(options?: any): JQuery;
	}
}

document.addEventListener('DOMContentLoaded', () => {
	for (const element of document.querySelectorAll(".excluded-by-region")) {
		element.remove();
	}
	$('.card-carousel .cards').slick({
		arrows: true,
		autoplay: false,
		autoplaySpeed: 10000,
		centerMode: false,
		centerPadding: 0,
		cssEase: 'ease',
		dots: false,
		draggable: true,
		fade: false,
		infinite: true,
		pauseOnHover: false,
		slidesToShow: 3,
		variableWidth: false,
		slidesToScroll: 1,
		speed: 350,
		responsive: [
			{
				breakpoint: 800,
				settings: {
					slidesToShow: 2,
					slidesToScroll: 1
				}
			},
			{
				breakpoint: 560,
				settings: {
					slidesToShow: 1,
					slidesToScroll: 1
				}
			}
		]
	});
})